import React, { useCallback, useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import login from 'modules/authentication/actions/login';

export const LoginForm = props => {
  const { history, location } = props;

  const dispatch = useDispatch();
  const isFirstVisit = useSelector(state => state?.session?.first_visit);
  const defaultRedirectTo = isFirstVisit ? '/dashboard/profile' : '/dashboard';
  const backTo = location?.state?.fromPage || defaultRedirectTo;
  const [loading, setLoading] = useState(false);

  const onLogin = useCallback(
    values => {
      setLoading(true);
      return new Promise(resolve => {
        dispatch(
          login(values, errors => {
            if (Object.values(errors).length === 0) {
              history.replace(backTo);

              if (isFirstVisit) {
                message.success('Bienvenido! Este es tu perfil!');
              } else {
                message.success('Has iniciado sesión correctamente.');
              }
              return;
            }
            message.error('Algo ocurrió mal. Por favor verifica tus credenciales.');
            setLoading(false);
            resolve(errors);
          }),
        );
      });
    },
    [backTo, dispatch, history, isFirstVisit],
  );

  return (
    <>
      <Form layout="vertical" name="login-form" onFinish={onLogin}>
        <Form.Item
          className="show-error-help"
          name="email"
          label="Correo electrónico"
          rules={[
            {
              required: true,
              message: 'Requerido',
            },
            {
              type: 'email',
              message: 'Verifica que el correo sea válido',
            },
          ]}
        >
          <Input prefix={<MailOutlined className="text-primary" />} />
        </Form.Item>
        <Form.Item
          className="show-error-help"
          name="password"
          label={
            <div className="d-flex justify-content-between w-100 align-items-center">
              <span>Contraseña</span>
              <Link to="/forgot-password" className="font-size-sm font-weight-normal text-muted">
                Olvidé mi contraseña
              </Link>
            </div>
          }
          rules={[
            {
              required: true,
              message: 'Requerido',
            },
          ]}
        >
          <Input.Password prefix={<LockOutlined className="text-primary" />} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Ingresar
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginForm;
